import ConfirmationModal from 'components/SharedComponents/Modals/ConfirmationModal';
import React from 'react';
import { useDeleteUserGroup } from 'hooks/userGroups/useDeleteUserGroup';
import { useTranslation } from 'react-i18next';

type DeleteUserModalProps = {
    isOpen: boolean;
    onClose: () => void;
    userGroupId: number;
};

const DeleteUserGroupModal = ({
    isOpen,
    onClose,
    userGroupId,
}: DeleteUserModalProps): JSX.Element => {
    const { t } = useTranslation();

    const deleteUserGroupMutation = useDeleteUserGroup(userGroupId);
    return (
        <ConfirmationModal
            isOpen={isOpen}
            title={t('adminSpace.deleteUserGroup.title')}
            text={t('adminSpace.deleteUserGroup.modalContent')}
            onConfirm={() => {
                deleteUserGroupMutation.mutate();
                onClose();
            }}
            onCancel={onClose}
            confirmClassName="pendo-delete-group-confirm"
        />
    );
};

export default DeleteUserGroupModal;
